export const LibConfig = {}
